import { FC } from 'react';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderInfoCss from '../../assets/header/header-info.module.scss';
import advertDetailHeaderTitleCss from '../../assets/header/header-title.module.scss';
import { HeaderInfoLocation } from '#advertDetail/components';

const HeaderInfo: FC = () => {
  const {
    advert: {
      name,
    },
  } = useAdvertDetailContext();

  return (
    <div className={advertDetailHeaderInfoCss.advertDetailHeaderInfo}>
      <h1 className={advertDetailHeaderTitleCss.advertDetailHeaderTitle}>
        {name}
      </h1>
      <HeaderInfoLocation />
    </div>
  );
};

export { HeaderInfo };
